var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar sidebar-vertical sidebar-right"},[(_vm.isPanelOpen)?_c('div',{staticClass:"sidebar-backdrop",on:{"click":_vm.toggleSidebarPanel}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }